import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LucideAngularModule,
  ChevronDownIcon,
  ChevronUpIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
  MessageCircleIcon,
  PhoneIcon,
  MapPinIcon,
} from 'lucide-angular';

@Component({
  selector: 'allas-mobile-footer',

  imports: [CommonModule, LucideAngularModule],
  templateUrl: 'mobile-footer.html',
})
export class MobileFooterComponent {
  @Input() currentYear: number = new Date().getFullYear();
  @Input() expandedSections: Record<string, boolean> = {};
  @Input() customerService: any[] = [];
  @Input() company: any[] = [];
  @Input() services: any[] = [];
  @Input() cities: any[] = [];
  @Input() shopping: any[] = [];
  @Input() categories: any[] = [];

  @Output() toggleSection = new EventEmitter<string>();

  readonly chevronDownIcon = ChevronDownIcon;
  readonly chevronUpIcon = ChevronUpIcon;
  readonly facebookIcon = FacebookIcon;
  readonly instagramIcon = InstagramIcon;
  readonly twitterIcon = TwitterIcon;
  readonly youtubeIcon = YoutubeIcon;
  readonly messageCircleIcon = MessageCircleIcon;
  readonly phoneIcon = PhoneIcon;
  readonly mapPinIcon = MapPinIcon;

  onToggleSection(section: string): void {
    this.toggleSection.emit(section);
  }
}
